// src/config/constants.js
// Centraliza las constantes del sistema para fácil configuración entre entornos.

// Correo del Super Usuario (Dueño/Desarrollador)
// Se lee de la variable de entorno REACT_APP_SUPER_USER_EMAIL del archivo .env
// Si no existe (ej: en local sin configurar), usa el valor por defecto de Producción.
export const SUPER_USER_EMAIL = process.env.REACT_APP_SUPER_USER_EMAIL || 'nelson.jtapia@gmail.com';

// Nombre de la aplicación (para títulos o encabezados)
export const APP_NAME = process.env.REACT_APP_NAME || 'BantCore System';